import React from 'react';
import { connect } from 'react-redux';
import { debounce } from 'lodash';
import { PREFILL_CONTENT_SEARCH, TOGGLE_SEARCH_PREVIEW } from 'components/TopBar/actions.js';
import { TOGGLE_ADVANCED_SEARCH } from 'components/Pages/AdvancedSearch/actions.js';
import Mixpanel from 'helpers/Mixpanel.js';
import {
  StyledAdvancedSearchLink,
  SearchHeaderContainer,
  SearchContainer,
  StyledSearchInput,
  ContinueArrowIcon,
  SearchIcon,
  SearchButton,
  SearchSection,
} from './styled.js';


class SearchHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchQuery: '',
    };
    this.prefillSearch = debounce(val => this.props.prefillSearch(val), 500);
  }

  componentDidUpdate(prevProps, prevState) {
    /* Wipe out input if incoming searchQuery is empty (from closing out of SearchBar */
    if (this.props.open !== prevProps.open && this.props.searchQuery !== prevState.searchQuery) {
      this.setState({ searchQuery: '' });
    }
  }

  handleSearch(val) {
    this.setState({ searchQuery: val }, () => {
      const trimmedVal = val.trim();
      if (trimmedVal.length > 2) {
        this.prefillSearch(trimmedVal);
      }
    });
  }

  handleSubmit(evt) {
    evt.preventDefault();
    const { toggleSearch } = this.props;
    toggleSearch();
  }

  render() {
    const { toggleAdvancedSearchModal } = this.props;
    const { searchQuery } = this.state;
    const placeholder = 'Search for Brands, Publishers, Content Titles, Keywords, URLs...';
    return (
      <SearchHeaderContainer>
        <SearchSection>
          <SearchContainer onSubmit={evt => this.handleSubmit(evt)}>
            <SearchIcon />
            <StyledSearchInput
              onChange={evt => this.handleSearch(evt.target.value)}
              placeholder={placeholder}
              onClick={() => Mixpanel.track('clicked home search input')}
              value={searchQuery}
            />
            <SearchButton
              show={searchQuery.trim().length > 2}
              onClick={() => {
                Mixpanel.track('submitted search'); this.props.toggleSearch();
              }}
            >
            SEARCH
            </SearchButton>
          </SearchContainer>
          <StyledAdvancedSearchLink
            onClick={() => {
              Mixpanel.track('clicked Do More With Advanced Search');
              toggleAdvancedSearchModal();
            }}
          >
            Do More With Advanced Search
            <ContinueArrowIcon />
          </StyledAdvancedSearchLink>
        </SearchSection>
      </SearchHeaderContainer>
    );
  }
}

const mapStateToProps = ({ SearchPreview: { searchResults, searchQuery, open } }) => ({
  searchResults,
  searchQuery,
  open,
});

const mapDispatchToProps = dispatch => ({
  prefillSearch: searchQuery => dispatch({ type: PREFILL_CONTENT_SEARCH, searchQuery }),
  toggleSearch: () => dispatch({ type: TOGGLE_SEARCH_PREVIEW, open: true }),
  toggleAdvancedSearchModal: () => dispatch({ type: TOGGLE_ADVANCED_SEARCH }),
});

export default connect(mapStateToProps, mapDispatchToProps)(SearchHeader);
